import MarketingTools from '@components/LocalMerchant/MarketingTools'
import Tabs from '@components/LocalMerchant/MarketingTools/Tabs'
import SetGift from '@components/LocalMerchant/MarketingTools/SetGift'
import SetPromise from '@components/LocalMerchant/MarketingTools/SetPromise'
import SetBack from '@components/LocalMerchant/MarketingTools/SetBack'
import TagList from '@components/LocalMerchant/MarketingTools/TagList'
import HotTagImg from '@components/LocalMerchant/MarketingTools/HotTagImg'
// import EditCoupon from '@components/LocalMerchant/MarketingTools/EditCoupon'
import SetConsultGift from '@components/LocalMerchant/MarketingTools/SetConsultGift'

export default {
  path: 'marketingTools',
  component: MarketingTools,
  indexRoute: {
    component: Tabs
  },
  childRoutes: [
    {
      path: 'setGift',
      component: SetGift,
      stat: '设置到店礼'
    },
    {
      path: 'setPromise',
      component: SetPromise,
      stat: '设置商家承诺'
    },
    {
      path: 'setBack',
      component: SetBack,
      stat: '设置订单可退'
    },
    {
      path: 'tagList/:id',
      component: TagList,
      stat: '设置人气推荐'
    },
    {
      path: 'hotTagImg',
      component: HotTagImg,
      stat: '设置套餐热标'
    },
    {
      path: 'setConsultGift',
      component: SetConsultGift,
      stat: '设置咨询礼'
    }
    // {
    //     path: 'editCoupon(/:id)',
    //     component:EditCoupon
    // }
  ]
}
